import ExportJsonExcel from 'js-export-excel';
import { dayFormatType, formatDay } from '~helpers/day';

export const handleExportToExcel = (
  t,
  exportData,
  startIndex,
  isMessageProperty = true,
  callback = () => {},
) => {
  const sheetHeader = [
    'Index',
    'Listing Plan',
    'Landlord Name',
    'Booking Number',
    'Student Name',
    'Snapshot Student Name',
    'Booking status',
    'Create Date',
    'Commission',
  ];

  const xlsxData = exportData?.edges?.map((data, index) => {
    return {
      index: startIndex + index,
      bookingJourney: isMessageProperty ? 'Book' : 'Booking width Consultant',
      landlordName: data?.node?.landlord?.name,
      bookingNumber: data?.node?.referenceId,
      studentName: data?.node?.student?.fullName || '-',
      snapshotStudentName: data?.node?.passportFullName || '-',
      bookingStatus: data?.node?.stage
        ? t(`cms.booking.message_property.table.booking_status.${data?.node?.stage?.toLowerCase()}`)
        : '-',
      createDate: data?.node?.createdAt
        ? formatDay(dayFormatType.UKWITHHM, data?.node?.createdAt)
        : '-',
      commission:
        data?.node?.commissions?.length > 0 &&
        data?.node?.commissions[0]?.currency &&
        data?.node?.commissions[0]?.totalPrice !== undefined
          ? data?.node?.commissions[0]?.currency + data?.node?.commissions[0]?.totalPrice
          : '-',
    };
  });
  const option = {};
  option['fileName'] = isMessageProperty
    ? 'Booking -- Book'
    : 'Booking -- Booking width Consultant';

  option['datas'] = [
    {
      sheetData: xlsxData,
      sheetHeader,
    },
  ];
  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
  callback();
};
